import {
  getRelationshipsQuery,
  subscribedRelationshipOwners,
} from '@griply/services';
import { FirestoreCollections, IDPrefixes, Relationship } from '@griply/types';
import {
  CollectionReference,
  documentId,
  FieldPath,
  Firestore,
  getDocs,
  Query,
  QueryConstraint,
} from 'firebase/firestore';

import { relationshipConverter } from './converters/relationships';
import {
  getAuthentication,
  getCollection,
  getDatabase,
  query,
  where,
} from './helpers';

export const getRelationships = async (owner: IDPrefixes) => {
  const auth = await getAuthentication();

  return getRelationshipsQuery<
    CollectionReference<Relationship>,
    Query<Relationship>,
    QueryConstraint,
    FieldPath,
    Firestore
  >({
    db: getDatabase(),
    collection: () =>
      getCollection(FirestoreCollections.Relationships).withConverter(
        relationshipConverter,
      ),
    query: query as (
      ref: CollectionReference<Relationship>,
      ...constraints: QueryConstraint[]
    ) => Query<Relationship>,
    where: where as (
      field: string | FieldPath,
      op: string,
      value: unknown,
    ) => QueryConstraint,
    documentId,
    userId: auth.currentUser?.uid ?? '',
    owner,
  });
};

// The live set only — task-owned docs are read per task.
export const getRelationshipDocs = async () => {
  const snapshots = await Promise.all(
    subscribedRelationshipOwners.map(async (owner) =>
      getDocs(await getRelationships(owner)),
    ),
  );

  return snapshots.flatMap((snapshot) =>
    snapshot.docs.map((doc) => doc.data()),
  );
};
